// import
import React, { Component }  from 'react';
import Homepage from "views/Dashboard/Homepage";
import Stats from "views/Dashboard/cards/Stats.js";
import Incident from "views/Dashboard/cards/Incident.js";
import SignIn from "views/Pages/SignIn.js";
import Sk from "views/Dashboard/cards/Sk"
import Edit from "views/Dashboard/cards/Edit"

import OspIncident from "views/Dashboard/cards/OspIncident"
import OspStats from "views/Dashboard/cards/OspStats"

import KMCR from "views/Dashboard/sgrmed/kmcr"
import KZW from "views/Dashboard/sgrmed/kzw"

import CardSgpr from "views/Dashboard/sgpr/card"
import CardSgrt from "views/Dashboard/sgrt/card"
import CardSgrchem from "views/Dashboard/sgrchem/card"

import Adr from "views/Dashboard/sgrchem/adr"

import CardSearch from "views/Dashboard/management/cardSearch"

import {
  HomeIcon,
  StatsIcon,
  CreditIcon,
  PersonIcon,
  DocumentIcon,
  RocketIcon,
  SupportIcon,
} from "components/Icons/Icons";

import {FaGraduationCap, FaWrench, FaStar, FaUsers} from "react-icons/fa"

import Raport from "./views/Dashboard/k-t/raport";
import DisabledVehicles from "./views/Dashboard/k-t/disabled-vehicles";

import Technical from "./views/Dashboard/swd/technical";
import Commands from "./views/Dashboard/swd/commands";
import {
  FaArrowTrendUp,
  FaBriefcase,
  FaCarBurst,
  FaFileLines, FaFireExtinguisher, FaFireFlameCurved, FaHandshakeSimple, FaHouseChimney, FaHouseChimneyCrack,
  FaHouseFire,
  FaListCheck, FaMapLocationDot,
  FaMarker,
  FaPaperclip,
  FaRectangleList, FaScroll,
  FaTableList, FaComputer, FaHospital,
  FaTruckMedical
} from "react-icons/fa6";
import TransferConfirm from "./views/Dashboard/another/transfer-confirm";
import ReportMinorAccident from "./views/Dashboard/another/report-minor-accident";
import ReportHeavyAccident from "./views/Dashboard/another/report-heavy-accident";
import ReportVehicleAccident from "./views/Dashboard/another/report-vehicle-accident";
import FaultsDemands from "./views/Dashboard/another/faults-demands";
import Inspection from "./views/Dashboard/k-r/inspection";
import Analysis from "./views/Dashboard/k-r/analysis";
import S4Preview from "./views/Dashboard/management/s4-preview";
import S4 from "./views/Dashboard/another/s4";
import S4PreviewOffcers from "./views/Dashboard/another/s4-preview";
import Minutes from "./views/Dashboard/management/minutes";
import MinutesOsp from "./views/Dashboard/management/minutesOsp";

import ChangesStats from "./views/Dashboard/management/changes-stats";

import zOne from "./views/Dashboard/r-z/z-one";
import zTwo from "./views/Dashboard/r-z/z-two";
import zPreview from "./views/Dashboard/r-z/preview";

import jOne from "./views/Dashboard/r-j/jrg-one";
import jTwo from "./views/Dashboard/r-j/jrg-two";
import jPreview from "./views/Dashboard/r-j/preview";

import Semestr from './views/Dashboard/school/semestr';
import Presence from './views/Dashboard/school/presence';
import Ratings from './views/Dashboard/school/ratings';

var dashRoutes = [
  {
    path: "/homepage",
    name: "Strona główna",
    icon: <FaHouseChimney color='inherit' />,
    component: Homepage,
    perms: "973950338405109811",
    layout: "/swd",
  },
  {
    path: "/stats",
    name: "Statystyki",
    icon: <FaArrowTrendUp color='inherit' />,
    component: Stats,
    perms: "973950338405109811",
    layout: "/swd",
  },
  {
    path: "/cards/sk",
    name: "Raport SK",
    icon: <FaComputer color='inherit' />,
    component: Sk,
    perms: "973950338405109811",
    layout: "/swd",
  },
  {
    path: "/cards/incident",
    name: "Karty wyjazdowe",
    icon: <FaFireExtinguisher color='inherit' />,
    component: Incident,
    perms: "973950338405109811",
    layout: "/swd",
  },
  {
    path: "/cards/edit",
    name: "Edycja kart",
    icon: <DocumentIcon color='inherit' />,
    component: Edit,
    perms: "973950338405109811",
    layout: "/swd",
  },
  {
    path: "/osp/incident",
    name: "Karta wyjazdowa OSP",
    icon: <FaFireExtinguisher color='inherit' />,
    component: OspIncident,
    perms: '1381380054180823171',
    layout: "/swd",
  },
    {
    path: "/osp/stats",
    name: "Statystyki OSP",
    icon: <FaArrowTrendUp color='inherit' />,
    component: OspStats,
    perms: '1381380054180823171',
    layout: "/swd",
  },
  {
    name: "Inne",
    category: "account",
    state: "pageCollapse",
    perms: "973950338405109811",
    views: [
      {
        path: "/another/transfer-confirm",
        name: "Potwierdzenie przekazania",
        icon: <FaHandshakeSimple color='inherit' />,
        secondaryNavbar: true,
        categoryName: "Inne",
        component: TransferConfirm,
        perms: "973950338405109811",
        layout: "/swd",
      },
      {
        path: "/another/report-minor-accident",
        name: "Meldunek o wypadku lekkim",
        icon: <FaBriefcase color='inherit' />,
        secondaryNavbar: true,
        categoryName: "Inne",
        component: ReportMinorAccident,
        perms: "973950338405109811",
        layout: "/swd",
      },
      {
        path: "/another/report-heavy-accident",
        name: "Meldunek o wypadku ciężkim",
        icon: <FaHospital color='inherit' />,
        secondaryNavbar: true,
        categoryName: "Inne",
        component: ReportHeavyAccident,
        perms: "973950338405109811",
        layout: "/swd",
      },
      {
        path: "/another/report-vehicle-accident",
        name: "Meldunek o wypadku pojazdu",
        icon: <FaCarBurst color='inherit' />,
        secondaryNavbar: true,
        categoryName: "Inne",
        component: ReportVehicleAccident,
        perms: "973950338405109811",
        layout: "/swd",
      },
      {
        path: "/another/faults-demands",
        name: "Usterki i Zapotrzebowania",
        icon: <FaHouseChimneyCrack color='inherit' />,
        secondaryNavbar: true,
        categoryName: "Inne",
        component: FaultsDemands,
        perms: "973950338405109811",
        layout: "/swd",
      },
      {
        path: "/another/s4",
        name: "S4",
        icon: <FaPaperclip color='inherit' />,
        secondaryNavbar: true,
        categoryName: "Inne",
        component: S4,
        perms: "973950338405109811",
        layout: "/swd",
      },
    ],
  },
  {
    name: "Oficerowie",
    category: "account",
    state: "pageCollapse",
    perms: '973709313824673792',
    views: [
      {
        path: "/another/s4-preview",
        name: "Podgląd S4",
        icon: <FaPaperclip color='inherit' />,
        secondaryNavbar: true,
        categoryName: "Inne",
        perms: '973709313824673792',
        component: S4PreviewOffcers,
        layout: "/swd",
      }
    ]
  },
  {
    name: "SGPR",
    category: "account",
    state: "pageCollapse",
    // perms: '975138803100577863',
    perms: '975138802643402835',
    views: [
      {
        path: "/sgpr/card",
        name: "Ewidencja",
        categoryName: "SGPR",
        icon: <FaScroll color='inherit' />,
        secondaryNavbar: true,
        // perms: '975138803100577863',
        perms: '975138802643402835',
        component: CardSgpr,
        layout: "/swd",
      },
    ],
  },
  {
    name: "SGRT",
    category: "account",
    state: "pageCollapse",
    // perms: '975138803100577863',
    perms: '975140566289510451',
    views: [
      {
        path: "/sgrt/card",
        name: "Ewidencja",
        categoryName: "SGRT",
        icon: <FaScroll color='inherit' />,
        secondaryNavbar: true,
        // perms: '975138803100577863',
        perms: '975140566289510451',
        component: CardSgrt,
        layout: "/swd",
      },
    ],
  },
  {
    name: "SGRChem",
    category: "account",
    state: "pageCollapse",
    // perms: '975138803100577863',
    perms: '975138802114891806',
    views: [
      {
        path: "/sgrchem/card",
        name: "Ewidencja",
        categoryName: "SGRChem",
        icon: <FaScroll color='inherit' />,
        secondaryNavbar: true,
        // perms: '975138803100577863',
        perms: '975138802114891806',
        component: CardSgrchem,
        layout: "/swd",
      },
      {
        path: "/sgrchem/adr",
        name: "ADR",
        categoryName: "SGRChem",
        icon: <FaScroll color='inherit' />,
        secondaryNavbar: true,
        // perms: '975138803100577863',
        perms: '975138802114891806',
        component: Adr,
        layout: "/swd",
      },
    ],
  },
  {
    name: "SGRMed",
    category: "account",
    state: "pageCollapse",
    // perms: '975138803100577863',
    perms: '1190995987154616381',
    views: [
      {
        path: "/sgrmed/kmcr",
        name: "KMCR",
        categoryName: "SGRMed",
        icon: <FaTruckMedical color='inherit' />,
        secondaryNavbar: true,
        // perms: '975138803100577863',
        perms: '1190995987154616381',
        component: KMCR,
        layout: "/swd",
      },
      {
        path: "/sgrmed/kzw",
        name: "KZW",
        categoryName: "SGRMed",
        icon: <FaTruckMedical color='inherit' />,
        secondaryNavbar: true,
        // perms: '975138803100577863',
        perms: '1190995987154616381',
        component: KZW,
        layout: "/swd",
      },
    ],
  },
  {
    name: "Wydział Kwatermistrzowski",
    category: "account",
    state: "pageCollapse",
    perms: '975147341550088203',
    views: [
      {
        path: "/k-t/raport",
        name: "Raport",
        categoryName: "Wydział Kwatermistrzowski",
        icon: <FaScroll color='inherit' />,
        secondaryNavbar: true,
        perms: '975147341550088203',
        component: Raport,
        layout: "/swd",
      },
      {
        path: "/k-t/disabled-vehicles",
        name: "Wycofane pojazdy",
        categoryName: "Wydział Kwatermistrzowski",
        icon: <FaCarBurst color='inherit' />,
        secondaryNavbar: true,
        perms: '975147341550088203',
        component: DisabledVehicles,
        layout: "/swd",
      },
    ],
  },
  {
    name: "Wydział Kontrolno Rozpoznawczy",
    category: "account",
    state: "pageCollapse",
    perms: '975147346675507240',
    views: [
      {
        path: "/k-r/inspection",
        name: "Inspekcja",
        categoryName: "Wydział Kontrolno Rozpoznawczy",
        icon: <FaMapLocationDot color='inherit' />,
        secondaryNavbar: true,
        perms: '975147346675507240',
        component: Inspection,
        layout: "/swd",
      },
      {
        path: "/k-r/fire-analysis",
        name: "Analiza pożarów",
        categoryName: "Wydział Kontrolno Rozpoznawczy",
        icon: <FaFireFlameCurved color='inherit' />,
        secondaryNavbar: true,
        perms: '975147346675507240',
        component: Analysis,
        layout: "/swd",
      },
    ],
  },
  {
    name: "Raporty zmianowe",
    category: "account",
    state: "pageCollapse",
    perms: '951126052871225374',
    views: [
      {
        path: "/r-z/main",
        name: "Podgląd",
        categoryName: "Raporty zmianowe",
        icon: <FaListCheck color='inherit' />,
        secondaryNavbar: true,
        perms: '951126052871225374',
        component: zPreview,
        layout: "/swd",
      },
      {
        path: "/r-z/z-one",
        name: "Zmiana I",
        categoryName: "Raporty zmianowe",
        icon: <FaFileLines color='inherit' />,
        secondaryNavbar: true,
        perms: '951126052871225374',
        component: zOne,
        layout: "/swd",
      },
      {
        path: "/r-z/z-two",
        name: "Zmiana II",
        categoryName: "Raporty zmianowe",
        icon: <FaFileLines color='inherit' />,
        secondaryNavbar: true,
        perms: '951126052871225374',
        component: zTwo,
        layout: "/swd",
      },
    ],
  },
  {
    name: "Raporty jednostek",
    category: "account",
    state: "pageCollapse",
    perms: '951125741507067934',
    views: [
      {
        path: "/r-j/main",
        name: "Podgląd",
        categoryName: "Raporty jednostek",
        icon: <FaListCheck color='inherit' />,
        secondaryNavbar: true,
        perms: '951125741507067934',
        component: jPreview,
        layout: "/swd",
      },
      {
        path: "/r-j/jrg-one",
        name: "JRG I",
        categoryName: "Raporty jednostek",
        icon: <FaHouseFire color='inherit' />,
        secondaryNavbar: true,
        perms: '951125741507067934',
        component: jOne,
        layout: "/swd",
      },
      {
        path: "/r-j/jrg-two",
        name: "JRG II",
        categoryName: "Raporty jednostek",
        icon: <FaHouseFire color='inherit' />,
        secondaryNavbar: true,
        perms: '951125741507067934',
        component: jTwo,
        layout: "/swd",
      },
    ],
  },
  {
    name: "Zarząd",
    category: "account",
    state: "pageCollapse",
    perms: '973337145844584538',
    views: [
      {
        path: "/manage/minuty",
        name: "Minuty",
        categoryName: "Zarząd",
        icon: <FaMarker color='inherit' />,
        secondaryNavbar: true,
        perms: '973337145844584538',
        component: Minutes,
        layout: "/swd",
      },
      {
        path: "/manage/s4-view",
        name: "S4 Podgląd",
        categoryName: "Zarząd",
        icon: <FaPaperclip color='inherit' />,
        secondaryNavbar: true,
        perms: '973337145844584538',
        component: S4Preview,
        layout: "/swd",
      },
      {
        path: "/manage/card-search",
        name: "Wyszukiwarka kart",
        categoryName: "Zarząd",
        icon: <FaRectangleList color='inherit' />,
        secondaryNavbar: true,
        perms: '973337145844584538',
        component: CardSearch,
        layout: "/swd",
      },
      {
        path: "/technical/swd",
        name: "Wozy bojowe",
        categoryName: "Techniczne",
        icon: <FaWrench color='inherit' />,
        secondaryNavbar: true,
        perms: '973337145844584538',
        component: Technical,
        layout: "/swd",
      },
      {
        path: "/technical/commands",
        name: "Komendy",
        categoryName: "Techniczne",
        icon: <FaWrench color='inherit' />,
        secondaryNavbar: true,
        perms: '973337145844584538',
        component: Commands,
        layout: "/swd",
      },
      {
        path: "/technical/changes-stats",
        name: "Statystyki zmian",
        categoryName: "Techniczne",
        icon: <FaWrench color='inherit' />,
        secondaryNavbar: true,
        perms: '973337145844584538',
        component: ChangesStats,
        layout: "/swd",
      },
    ],
  },
  {
    name: "Zarząd OSP",
    category: "account",
    state: "pageCollapse",
    perms: '1381377541318774834',
    views: [
      {
        path: "/manage-osp/minuty-osp",
        name: "Minuty OSP",
        categoryName: "Zarząd OSP",
        icon: <FaMarker color='inherit' />,
        secondaryNavbar: true,
        perms: '1381377541318774834',
        component: MinutesOsp,
        layout: "/swd",
      },
    ],
  },
  {
    name: "Szkoła Podoficerska",
    category: "account",
    state: "pageCollapse",
    perms: '1333466004701057085',
    views: [
      {
        path: "/school/company",
        name: "Kompanie",
        categoryName: "Szkoła Podoficerska",
        icon: <FaGraduationCap color='inherit' />,
        secondaryNavbar: true,
        perms: '1333466004701057085',
        component: Semestr,
        layout: "/swd",
      },
      {
        path: "/school/presence",
        name: "Frekwencja",
        categoryName: "Szkoła Podoficerska",
        icon: <FaUsers color='inherit' />,
        secondaryNavbar: true,
        perms: '1333466004701057085',
        component: Presence,
        layout: "/swd",
      },
      {
        path: "/school/ratings",
        name: "Oceny",
        categoryName: "Szkoła Podoficerska",
        icon: <FaStar color='inherit' />,
        secondaryNavbar: true,
        perms: '1333466004701057085',
        component: Ratings,
        layout: "/swd",
      },
    ]
  },
  {
    name: "Techniczne",
    category: "account",
    state: "pageCollapse",
    perms: '1190995987154616381',
    views: [
      {
        path: "/signin",
        name: "Logowanie",
        icon: <RocketIcon color='inherit' />,
        component: SignIn,
        layout: "/auth",
      },
    ],
  },
];
export default dashRoutes;
